module.exports = __webpack_public_path__ + "static/media/thumbnail.02c8c257.webp";